import { ClientRequestModel } from "libs/models/client";
import { ValidationModel } from "libs/models/validate-model";
import { ClientStore } from "store/slices/client";
import { decimalNumberRegex, numberRegex } from "utils/regex";
import translate from "utils/translations";

export const validateAddClientState = (
  state: ClientStore
): ValidationModel<ClientRequestModel> => {
  let validationModel = {} as ValidationModel<ClientRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (state.newClientData.name === null || state.newClientData.name === "") {
    validationModel.name = translate("Required_Text", "This field is required");
  }
  if (
    state.newClientData.name === null ||
    state.newClientData.name.length > 200
  ) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }
  if (
    state.newClientData.name !== null &&
    state.newClientData.name !== "" &&
    state.newClientData.name.length < 2
  ) {
    validationModel.name = translate("Short_Text", "Text is too short");
  }

  if (
    state.newClientData.website === null ||
    state.newClientData.website === ""
  ) {
    validationModel.website = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const websiteRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
  if (
    state.newClientData.website !== "" &&
    !websiteRegex.test(state.newClientData.website)
  ) {
    validationModel.website = translate("Website_Error", "Invalid Website");
  }
  if (state.newClientData.phone === null || state.newClientData.phone === "") {
    validationModel.phone = translate(
      "Required_Text",
      "This field is required"
    );
  }

  const phoneRegex = /^\d{4,11}$/;
  if (
    state.newClientData.phone !== "" &&
    !phoneRegex.test(state.newClientData.phone)
  ) {
    validationModel.phone = translate("Phone_Error", "Invalid phone");
  }
  if (
    state.newClientData.mobile === null ||
    state.newClientData.mobile === ""
  ) {
    validationModel.mobile = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const mobileRegex = /^(010|011|012|015)\d{8}$/;
  if (
    state.newClientData.mobile !== "" &&
    !mobileRegex.test(state.newClientData.mobile)
  ) {
    validationModel.mobile = translate("Mobile_Error", "Invalid mobile");
  }
  if (
    state.newClientData.clickingFees === undefined ||
    state.newClientData.clickingFees === 0
  ) {
    validationModel.clickingFees = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (
    state.newClientData.invoiceGenerationWeeklyPeriod === undefined ||
    state.newClientData.invoiceGenerationWeeklyPeriod === 0
  ) {
    validationModel.invoiceGenerationWeeklyPeriod = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (
    state.newClientData.clickingFees !== undefined &&
    !decimalNumberRegex.test(state.newClientData.clickingFees.toString())
  ) {
    validationModel.clickingFees = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.newClientData.invoiceGenerationWeeklyPeriod !== undefined &&
    !numberRegex.test(
      state.newClientData.invoiceGenerationWeeklyPeriod.toString()
    )
  ) {
    validationModel.invoiceGenerationWeeklyPeriod = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.commercialRegisterFiledId === null ||
    state.commercialRegisterFiledId === ""
  ) {
    validationModel.commercialRegisterFiled = translate(
      "Required_Text",
      "This field is required"
    );
  }
  if (state.logoId === null || state.logoId === "") {
    validationModel.logo = translate("Required_Text", "This field is required");
  }
  if (
    state.taxRegistrationFileId === null ||
    state.taxRegistrationFileId === ""
  ) {
    validationModel.taxRegistrationFile = translate(
      "Required_Text",
      "This field is required"
    );
  }
  return validationModel;
};
